import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { DatePicker, Form, Input } from 'antd';
import settings from 'settings';
import {
  assignmentCard, bookingCard, displayCard, getKey, getLabel, getNameLabel, getSelect, getSelects, userCard, userleaveCard
} from 'library/helpers';
import { list, load, reset } from 'actions';
import REDUCER_KEY from 'reducers/reducer.keys';
import { FormWrapper } from 'components/Page';
import ExtendedSelect from 'components/extendedSelect';
import TagSelector from 'components/tagSelector/tag-selector';
import AuthService from 'library/authService/auth-service';

const FormItem = Form.Item;
const { TextArea } = Input;

/**
 * @description Choose the display card based on the theme
 * @param {data} Object
 * @return element
 */
const getCard = (data) => {
  if (data.model === 'assignment') {
    return assignmentCard(data);
  }
  if (data.model === 'userleave') {
    return userleaveCard(data);
  }
  if (data.model === 'booking') {
    return bookingCard(data);
  }
  if (data.model === 'user') {
    return userCard(data);
  }

  return displayCard(data); // default display
};

/**
 * @description Map state to props
 * @param {state} Object
 */
const mapStateToProps = state => ({
  contextList: state.api.actionContextList.data.results,
  contextInFlight: state.api.actionContextList.inFlight,
  statusInFlight: state.api.actionStatusList.inFlight,
  statuses: state.api.actionStatusList.data.results,
  prioritiesInFlight: state.api.actionPriorities.inFlight,
  priorities: state.api.actionPriorities.data.results,
  users: state.api.peopleData.data.results,
  userInFlight: state.api.peopleData.inFlight,
  notificationTypes: state.api.notificationTypes.data.results,
  notificationTypesInFlight: state.api.notificationTypes.inFlight,
  actionTypes: state.api.actionTypes.data.results,
  actionTypesInFlight: state.api.actionTypes.inFlight,
  actionType: state.api.actionType.data
});
/**
 * @description Redux dispatch functions
 * @param {dispatch} Function
 */
const mapDispatchToProps = dispatch => ({
  loadActionContext() {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [{
      id: 'active',
      value: true
    }];

    dispatch(list(REDUCER_KEY.actionContextList.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  },
  loadActionType(data) {
    const { key: id } = data || { key: -1 }; // either fetch an existing action_type or reset the store
    if (id > 0) {
      dispatch(load(REDUCER_KEY.actionType.key, { id }));
    }
    else {
      dispatch(reset(REDUCER_KEY.actionType.key));
    }
  },
  loadActionTypes(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [{
      id: 'active',
      value: true
    }];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }

    dispatch(list(REDUCER_KEY.actionTypes.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  },
  loadStatus(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [{
      id: 'active',
      value: true
    }];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }

    dispatch(list(REDUCER_KEY.actionStatusList.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  },
  loadPriorities(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [{
      id: 'active',
      value: true
    }];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }

    dispatch(list(REDUCER_KEY.actionPriorities.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  },
  loadUsers(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'last_name',
      desc: false
    }];
    const filters = [{
      id: 'is_active',
      value: true
    }];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'last_name__icontains',
        value: searchText
      });
    }

    dispatch(list(REDUCER_KEY.peopleData.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  },
  loadNotificationTypes(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [{
      id: 'active',
      value: true
    }];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }

    dispatch(list(REDUCER_KEY.notificationTypes.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  }
});

const mapPropsToFields = () => {
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};
/**
 * @component FormInput
 * @param {props} Object
 */
const FormInput = ({
  canAdmin,
  form,
  dataSource,
  inputFormItemLayout,
  loadActionContext,
  loadActionTypes,
  loadActionType,
  loadNotificationTypes,
  loadPriorities,
  loadStatus,
  loadUsers,
  actionType,
  actionTypes,
  actionTypesInFlight,
  contextList,
  contextInFlight,
  notificationTypes,
  priorities,
  statuses,
  users,
  notificationTypesInFlight,
  prioritiesInFlight,
  statusInFlight,
  usersInFlight,
  item,
  theme
}) => {
  const { getFieldDecorator } = form;
  // dataource
  const {
    id,
    assignees,
    priority,
    requestor,
    status,
    tags,
    context_object,
    context_theme,
    follow_up_date,
    notification_types,
    description,
    action_type,
    created_date,
    created_user
  } = dataSource;

  const selectedTheme = contextList.find(data => data.model === theme); // extract the current theme
  const isEditMode = id > 0; // is an action loaded
  const isDefault = !_.isEmpty(actionType) || !_.isEmpty(action_type); // is the form in a state of default
  const readonly = !canAdmin && id > 0;

  const card = {
    ...item,
    ...context_theme,
    ...context_object
  };

  if (context_object && context_object.itinerary) {
    const { user } = context_object.itinerary;
    card.user = user;
  }

  // Create hooks for tag and user state
  const [defaults, setDefaults] = useState({});
  const [needTags, setTagsNeeded] = useState(true);
  const [needUsers, setUsersNeeded] = useState(true);
  const [whoami] = useState(AuthService.whoami());
  useEffect(() => {
    if (!users.length) {
      loadUsers(); // load users on initial load
    }
    // get current form values
    if (!users.length) {
      loadUsers(); // load users on initial load
    }
    const assignedUsers = form.getFieldValue('assignees') || [];
    const assignedTags = form.getFieldValue('tags') || [];
    const userErrors = form.getFieldError('assignees') || [];
    const tagErrors = form.getFieldError('tags') || [];
    // clear the relating field if either have values
    if (assignedTags.length && userErrors.length) {
      form.setFields({
        assignees: {
          value: assignedUsers,
          errors: undefined
        }
      });
    }
    else if (assignedUsers.length && tagErrors.length) {
      form.setFields({
        tags: {
          value: assignedTags,
          errors: undefined
        }
      });
    }
    // Update flags
    setUsersNeeded(!assignedTags.length);
    setTagsNeeded(!assignedUsers.length);
  });

  // get default values and initialise the default_description if description present
  useEffect(() => {
    setDefaults({
      ...action_type,
      ...actionType,
      ...(description) && { default_description: description }
    });
  }, [actionType]);

  // keep default_description updated now that we have a description
  useEffect(() => {
    setDefaults({
      ...defaults,
      default_description: description
    });
  }, [description]);

  // default values
  const {
    default_assignees,
    default_priority,
    default_status,
    default_user_assignee_tags,
    default_notification_types,
    default_description
  } = defaults;

  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Action ID">
        {
          getFieldDecorator('id', {
            initialValue: id < 0 ? 'None' : id
          })(
            <Input disabled />
          )
        }
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Type">
        {
          getFieldDecorator('action_type', {
            initialValue: getSelect(action_type),
            rules: [{
              required: true,
              message: 'Please select an Action Type.'
            }]
          })(
            <ExtendedSelect
              fetching={actionTypesInFlight}
              placeholder="Select action type"
              optionKey={getKey}
              optionLabel={getLabel}
              disabled={isEditMode}
              onSearch={loadActionTypes}
              onFocus={loadActionTypes}
              onChange={loadActionType}
              dataSource={actionTypes}
            />
          )
        }
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Status">
        {getFieldDecorator('status', {
          initialValue: getSelect(status, default_status),
          rules: [
            {
              required: true,
              message: 'Please select a Status.'
            }
          ]
        })(
          <ExtendedSelect
            fetching={statusInFlight}
            placeholder="Select status"
            optionKey={getKey}
            optionLabel={getLabel}
            disabled={readonly || !isDefault}
            onSearch={loadStatus}
            onFocus={loadStatus}
            dataSource={statuses}
          />
        )}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Priority">
        {getFieldDecorator('priority', {
          initialValue: getSelect(priority, default_priority),
          rules: [
            {
              required: true,
              message: 'Please select a Priority.'
            }
          ]
        })(
          <ExtendedSelect
            fetching={prioritiesInFlight}
            placeholder="Select priority"
            optionKey={getKey}
            optionLabel={getLabel}
            disabled={readonly || !isDefault}
            onSearch={loadPriorities}
            onFocus={loadPriorities}
            dataSource={priorities}
          />
        )}
      </FormItem>
      <FormItem
        {...inputFormItemLayout}
        label="Assignees"
        extra={!isEditMode ? 'Select either Users and/or the relevant User Tags' : ''}
      >
        {getFieldDecorator('assignees', {
          initialValue: getSelects(assignees, ['last_name', 'first_name'], default_assignees),
          rules: [
            {
              required: isEditMode || needUsers,
              message: 'Please assign the action to users.'
            }
          ]
        })(
          <ExtendedSelect
            mode="multiple"
            fetching={usersInFlight}
            placeholder="Select assignees"
            optionKey={getKey}
            optionLabel={getNameLabel}
            disabled={readonly || !isDefault}
            onSearch={loadUsers}
            onFocus={loadUsers}
            dataSource={users}
          />
        )}
      </FormItem>
      {!isEditMode && (
        <FormItem {...inputFormItemLayout} label="Tags">
          {getFieldDecorator('tags', {
            initialValue: tags && tags.length ? tags.map(data => ({
              key: data.id || data.key,
              label: data.qualified_name || data.label
            })) : getSelects(default_user_assignee_tags),
            rules: [
              {
                required: needTags,
                message: 'Please assign users via User Tags.'
              }
            ]
          })(
            <TagSelector
              theme="user"
              placeholder="Select tags"
              tagSelectorReducerKey={REDUCER_KEY.userCollectionValues}
              disabled={readonly || !isDefault || isEditMode}
              maxTagCount={5}
            />
          )}
        </FormItem>
      )}
      <FormItem {...inputFormItemLayout} label="Notification Types">
        {getFieldDecorator('notification_types', {
          initialValue: getSelects(notification_types, ['name'], default_notification_types),
          rules: [
            {
              required: true,
              message: 'Please select a Notification Type.'
            }
          ]
        })(
          <ExtendedSelect
            mode="multiple"
            fetching={notificationTypesInFlight}
            placeholder="Select notifications"
            optionKey={getKey}
            optionLabel={getLabel}
            disabled={readonly || !isDefault}
            onSearch={loadNotificationTypes}
            onFocus={loadNotificationTypes}
            dataSource={notificationTypes}
          />
        )}
      </FormItem>
      {!_.isEmpty(context_object) && (
        <FormItem {...inputFormItemLayout} label="Context">
          {getCard(card)}
        </FormItem>
      )}
      {!_.isEmpty(selectedTheme) && !isEditMode && (
        <FormItem {...inputFormItemLayout} label="Theme" style={{ display: !_.isEmpty(selectedTheme) && !isEditMode ? 'none' : 'block' }}>
          {getFieldDecorator('context_theme', {
            initialValue: getSelect(selectedTheme, context_theme)
          })(
            <ExtendedSelect
              fetching={contextInFlight}
              placeholder="Select theme"
              optionKey={getKey}
              optionLabel={getLabel}
              disabled={!_.isEmpty(selectedTheme) || isEditMode || readonly || !isDefault}
              onSearch={loadActionContext}
              onFocus={loadActionContext}
              dataSource={contextList}
            />
          )}
        </FormItem>
      )}
      <FormItem {...inputFormItemLayout} label="Description">
        {getFieldDecorator('description', {
          initialValue: description || default_description,
          rules: [
            {
              required: true,
              message: 'Please select a Description.'
            }
          ]
        })(
          <TextArea
            disabled={readonly || !isDefault}
            rows={4}
          />
        )}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Requestor">
        {getFieldDecorator('requestor', {
          initialValue: getSelect(requestor, null, ['last_name', 'first_name']) || getSelect(whoami, null, ['lastName', 'firstName']),
          rules: [
            {
              required: true,
              message: 'Please select a requestor.'
            }
          ]
        })(
          <ExtendedSelect
            fetching={usersInFlight}
            placeholder="Select requestor"
            optionKey={getKey}
            optionLabel={getNameLabel}
            disabled={!canAdmin || readonly || !isDefault}
            onSearch={loadUsers}
            onFocus={loadUsers}
            dataSource={users}
          />
        )}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Follow Up">
        {getFieldDecorator('follow_up_date', {
          initialValue: follow_up_date ? moment(follow_up_date) : undefined
        })(
          <DatePicker
            showTime={{ format: 'HH:mm' }}
            disabled={readonly || !isDefault}
            format="DD-MM-YYYY HH:mm"
            disabledDate={current => current && current < moment()
              .startOf('day')}
          />
        )}
      </FormItem>
      {isEditMode && (
        <FormItem {...inputFormItemLayout} label="Created">
          {getFieldDecorator('created_date', {
            initialValue: created_date ? moment(created_date)
              .format('YYYY-MM-DD HH:mm') : undefined
          })(
            <Input disabled />
          )}
        </FormItem>
      )}
      {isEditMode && (
        <FormItem {...inputFormItemLayout} label="Created By">
          {getFieldDecorator('created_user', {
            initialValue: getSelect(created_user, null, ['last_name', 'first_name'])
          })(
            <ExtendedSelect
              placeholder="Created By"
              optionKey={getKey}
              optionLabel={getNameLabel}
              disabled
              dataSource={users}
            />
          )}
        </FormItem>
      )}
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  loadActionTypes: PropTypes.func,
  loadActionType: PropTypes.func,
  loadNotificationTypes: PropTypes.func,
  loadStatus: PropTypes.func,
  loadPriorities: PropTypes.func,
  loadUsers: PropTypes.func,
  loadActionContext: PropTypes.func,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func,
  actionType: PropTypes.object,
  actionTypes: PropTypes.array,
  contextList: PropTypes.array,
  contextInFlight: PropTypes.bool,
  actionTypesInFlight: PropTypes.bool,
  notificationTypes: PropTypes.array,
  priorities: PropTypes.array,
  prioritiesInFlight: PropTypes.bool,
  statuses: PropTypes.array,
  notificationTypesInFlight: PropTypes.bool,
  statusInFlight: PropTypes.bool,
  usersInFlight: PropTypes.bool,
  users: PropTypes.array,
  item: PropTypes.object,
  theme: PropTypes.string
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  loadActionTypes() {
  },
  loadActionType() {
  },
  loadStatus() {
  },
  loadNotificationTypes() {
  },
  loadPriorities() {
  },
  loadActionContext() {
  },
  loadUsers() {
  },
  onFieldsChange() {
  },
  onValuesChange() {
  },
  actionType: {},
  actionTypes: [],
  contextList: [],
  contextInFlight: false,
  actionTypesInFlight: false,
  notificationTypes: [],
  priorities: [],
  notificationTypesInFlight: false,
  prioritiesInFlight: false,
  statuses: [],
  statusInFlight: false,
  usersInFlight: false,
  users: [],
  item: {},
  theme: ''
};

const ActionInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(FormInput));

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(ActionInput);
